import * as React from "react";
import { Badge } from "../../badge/badge.mjs";
import { EqualHeight } from "../../equal-height/equal-height/equal-height.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
const HorizontalProgressItem = (props) => {
  const { headingLevel = 2 } = props;
  const BEM = () => {
    const classArray = ["horizontal-progress__item"];
    if (props.state) {
      classArray.push("is-" + props.state);
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const getIcon = () => {
    if (props.state === "done") {
      return "#check";
    }
    return "";
  };
  const getPurpose = () => {
    if (props.state === "done") {
      return "success";
    } else if (props.state === "current") {
      return "selected";
    } else {
      return "inactive";
    }
  };
  const ButtonTag = props.onTitleClick ? "button" : "span";
  return /* @__PURE__ */ React.createElement("li", { className: BEM() }, /* @__PURE__ */ React.createElement("div", { className: "horizontal-progress__header" }, /* @__PURE__ */ React.createElement("div", { className: "horizontal-progress__badge-wrapper" }, /* @__PURE__ */ React.createElement(Badge, { icon: getIcon(), size: "large", className: "horizontal-progress__counter", purpose: getPurpose(), responsiveSize: true })), /* @__PURE__ */ React.createElement("div", { className: "horizontal-progress__header-inner" }, /* @__PURE__ */ React.createElement("div", { className: "horizontal-progress__header-title-section" }, /* @__PURE__ */ React.createElement(EqualHeight, { group: "horizontal-progress-item-title", align: "bottom" }, /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "horizontal-progress__title h4" }, /* @__PURE__ */ React.createElement(
    ButtonTag,
    {
      type: props.onTitleClick ? "button" : void 0,
      className: "horizontal-progress__button",
      onClick: props.onTitleClick,
      disabled: !(props.state === "current" || props.state === "done")
    },
    props.title
  )))))), /* @__PURE__ */ React.createElement("div", { className: "horizontal-progress__content" }, props.children));
};
export {
  HorizontalProgressItem
};
